import React from 'react';
import CustomItemModal from './CustomItemModal';

// Thin wrapper around the shared CustomItemModal, prefilled from the Portal or Media item being
// converted — same pattern ConvertPortalToMediaModal.jsx already uses. Option Type and calendar
// Start/End are intentionally left blank — no source type has that data, and it's a required
// field (decision #1, docs\Booth_Item_Cross_Type_Conversion_Plan.md section 4): the admin must
// pick an option and fill in the dates before Save is enabled, same as CustomItemModal's own
// existing validation already requires for a brand-new item.
//
// sourceType: 'portal' | 'media'.
const ConvertToCustomModal = ({ open, onClose, onSave, source, sourceType }) => {
  const initialNamePairs =
    sourceType === 'media'
      ? source?.textLocalizations?.map((v) => ({ localeId: v.localeId, value: v.value }))
      : source?.localizedPairs?.values?.map((v) => ({ localeId: v.localeId, value: v.value }));

  const initialImagePairs =
    sourceType === 'media'
      ? source?.linkLocalizations?.map((l) => ({ localeId: l.localeId, mediaLink: l.mediaLink }))
      : source?.correspondingMedia?.linkLocalizations?.map((l) => ({ localeId: l.localeId, mediaLink: l.mediaLink }));

  return (
    <CustomItemModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      initialNamePairs={initialNamePairs?.length ? initialNamePairs : undefined}
      initialImagePairs={initialImagePairs?.length ? initialImagePairs : undefined}
      title="Convert to Custom"
      subtitle="Name and image are carried over — pick an option and add calendar dates to finish."
      saveLabel="Convert to Custom"
    />
  );
};

export default ConvertToCustomModal;
